module.exports = __webpack_public_path__ + "static/media/iep-ui-design06.e609318a.png";